/**
 * 将时间戳（毫秒）格式化为日期字符串
 * @param timestamp - 时间戳（毫秒）
 * @param separator - 分隔符，默认 '-'
 *   - '-': 2026-04-02
 *   - '/': 2026/04/02
 *   - 'chinese': 2026年6月30日
 * @returns 格式化后的日期字符串
 */
export function formatTimestamp(timestamp, separator = '-') {
    try {
        if (!timestamp) {
            return '';
        }
        const date = new Date(timestamp);
        const Y = date.getFullYear();
        const M = date.getMonth() + 1;
        const D = date.getDate();
        if (separator === 'chinese') {
            return `${Y}年${M}月${D}日`;
        }
        const m = String(M).padStart(2, '0');
        const d = String(D).padStart(2, '0');
        return `${Y}${separator}${m}${separator}${d}`;
    }
    catch {
        return '';
    }
}
